const steps = [
  {
    title: "认准官方渠道",
    desc: "优先通过本页提供的下载入口获取安装包，避免从不明链接下载来路不明的版本。",
  },
  {
    title: "允许安装未知应用",
    desc: "部分安卓机型在安装第三方应用时会拦截，请在系统设置中为「文件管理 / 浏览器」开启允许安装应用。",
  },
  {
    title: "安装并登录",
    desc: "下载完成后点击安装包完成安装，打开应用按引导完成设置即可开始使用。",
  },
];

export default function Download() {
  return (
    <section id="download" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-primary-500 via-primary-600 to-accent-700 p-7 md:p-12">
          <div className="pointer-events-none absolute -right-10 -top-10 h-48 w-48 rounded-full bg-background-50/10"></div>
          <div className="pointer-events-none absolute -bottom-16 left-1/3 h-52 w-52 rounded-full bg-background-50/10"></div>

          <div className="relative grid grid-cols-1 items-center gap-8 lg:grid-cols-2">
            <div>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-background-50/20 px-3 py-1 text-xs font-bold text-background-50">
                <i className="ri-download-cloud-2-line"></i>安卓手机版下载
              </span>
              <h2 className="mt-4 font-heading text-3xl font-black tracking-tight text-background-50 md:text-4xl">
                下载吃瓜神器安卓版
              </h2>
              <p className="mt-3 max-w-lg text-sm leading-relaxed text-background-50/90 md:text-base">
                最新版 v5.2.1 · 约 46 MB · 适配安卓 6.0 及以上系统。下载后若提示风险或需开启权限，请按系统引导操作即可。
              </p>

              <div className="mt-6 flex flex-col gap-3 sm:flex-row">
                <a
                  href="#faq"
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-6 py-3.5 text-base font-bold text-primary-600 transition-colors hover:bg-background-100"
                >
                  <i className="ri-download-2-line text-lg"></i>下载安卓安装包
                </a>
                <a
                  href="#faq"
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/60 px-6 py-3.5 text-base font-semibold text-background-50 transition-colors hover:bg-background-50/10"
                >
                  <i className="ri-question-line text-lg"></i>安装遇到问题？
                </a>
              </div>

              <div className="mt-6 flex flex-wrap gap-x-6 gap-y-2 text-xs text-background-50/85">
                <span className="inline-flex items-center gap-1.5">
                  <i className="ri-shield-check-line"></i>官方稳定包
                </span>
                <span className="inline-flex items-center gap-1.5">
                  <i className="ri-refresh-line"></i>持续更新
                </span>
                <span className="inline-flex items-center gap-1.5">
                  <i className="ri-wifi-line"></i>建议 Wi-Fi 下载
                </span>
              </div>
            </div>

            <div className="flex flex-col gap-3 rounded-xl bg-background-50/10 p-5 backdrop-blur-sm">
              <p className="flex items-center gap-2 text-sm font-bold text-background-50">
                <i className="ri-tools-line"></i>三步完成安装
              </p>
              <ol className="flex flex-col gap-4">
                {steps.map((s, i) => (
                  <li key={s.title} className="flex items-start gap-3">
                    <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-background-50 text-xs font-black text-primary-600">
                      {i + 1}
                    </span>
                    <div>
                      <p className="text-sm font-semibold text-background-50">{s.title}</p>
                      <p className="mt-1 text-xs leading-relaxed text-background-50/85">{s.desc}</p>
                    </div>
                  </li>
                ))}
              </ol>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}